import $ from 'jquery';

const scroll_link = $('.hero-inner-block__button');

scroll_link.click(function() {
  const next_section = $(this).closest('.hero-inner-block').next()
  if(next_section) {
    next_section[0].scrollIntoView({ behavior: 'smooth' })
  }
})
